import { ReactNode } from 'react';

import classNames from 'classnames';

import { AnimatedEllipsis } from '@/components/AnimatedEllipsis';
import { Button, ButtonProps } from '@/components/Button';

export interface SubmitButtonProps extends Omit<ButtonProps, 'circle'> {
  loading?: boolean;
  disabled?: boolean;
  children?: ReactNode;
  className?: string;
}

export function SubmitButton({
  loading = false,
  disabled = false,
  children = 'Submit',
  className = 'relative',
  ...props
}: SubmitButtonProps) {
  return (
    <Button
      type="submit"
      className={className}
      disabled={loading || disabled}
      {...props}
    >
      <span
        className={classNames(
          'transition-opacity',
          loading ? 'opacity-0' : 'opacity-100',
        )}
      >
        {children}
      </span>
      <span
        className={classNames(
          'absolute inset-0 flex items-center justify-center text-paper pointer-events-none',
          loading ? 'opacity-100' : 'opacity-0',
        )}
      >
        <AnimatedEllipsis size="md" />
      </span>
    </Button>
  );
}
